import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3036">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3037">
        <div data-id="element-3038">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3039">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3040">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3041">
          <Card className="p-6" data-id="element-3042">
            <div className="flex items-center gap-4" data-id="element-3043">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3044">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3045" />
              </div>
              <div data-id="element-3046">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3047">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3048">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3049">
            <div className="flex items-center gap-4" data-id="element-3050">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3051">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3052" />
              </div>
              <div data-id="element-3053">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3054">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3055">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3056">
            <div className="flex items-center gap-4" data-id="element-3057">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3058">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3059" />
              </div>
              <div data-id="element-3060">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3061">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3062">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3063">
            <div className="flex items-center gap-4" data-id="element-3064">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3065">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3066" />
              </div>
              <div data-id="element-3067">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3068">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3069">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3070">
          <div className="p-6 border-b border-gray-200" data-id="element-3071">
            <h2 className="font-bold text-gray-900" data-id="element-3072">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3073">
            <table className="w-full text-left text-sm" data-id="element-3074">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3075">
                <tr data-id="element-3076">
                  <th className="px-6 py-4 font-medium" data-id="element-3077">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3078">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3079">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3080">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3081">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3082">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3083">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3084">
                {loading ? <tr data-id="element-3085">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3086">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3087">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3088">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3089">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3090">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3091">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3092">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3093">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3094">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3095">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3096">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3097">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}